"use strict";

var condition2DirectiveController = ["$scope", 'BuilderDataService', '$translate', 'toast', function ($scope, BuilderDataService, $translate, toast) {
    var _this = this;
    if (_this.form == undefined)
        _this.form = BuilderDataService.getForm();

    this.OperationLabels = {
      "=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.EQUAL'),
      "!=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.DISTINT'),
      "<": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.LESS'),
      ">": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.GREATER'),
      "<=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.LESS_EQUAL'),
      ">=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.GREATER_EQUAL'),
      "existe": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.EXISTS'),
      "!existe": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.NOT_EXISTS')
    }

    this.getElement = function (fieldId) {
        var element = angular.copy(_this.lstElements.find(function (el) {
            return el.id == fieldId;
        }));
        return element;
    }

    this.validOperations = function (fieldId) {
        var element = _this.getElement(fieldId); 

        if (!element) {
            return [];
        }

        if (element.type === "fetchData") {
            element.type = element.fetchDataConfiguration.fieldData.type;
        }

        switch (element.type) {
            case "text":
            case "textarea":
            case "select":
            case "checkbox":
            case "multiple":
                return (_this.use === "datasource") ? ["="] : ["=", "!=", "existe", "!existe"];
            case "formula":
            case "date":
            case "timestamp":
            case "number":
            case "qr":
                return ["=", "!=", "<", ">", "<=", ">=", "existe", "!existe"];
            default:
                return [];
        }
    };

    this.removeCondition = function (index) {
        if (_this.use === "dynamic-select") {
            this.element.templateData.dynamicOptions.splice(index, 1);
        } else if (_this.use === "dynamic-group") {
            this.element.dynamicRequires.splice(index, 1);
        } else if (_this.use === "dynamic-mail") {
            this.element.reportDinamicCondition.splice(index, 1)
        } else if (_this.use === "datasource") {
            this.element.filters.splice(index, 1)
        } else {
            this.element.dynamicRequires.splice(index, 1);
        }
    };

    this.removeBlock = function (scope) {
        scope.remove();
        _this.valid = _this.validateConditions(_this.condition.conditions);
    };

    this.addBlock = function (operator, list) {
        switch (operator) {
            case "or":
                list.push({
                    type: "operator",
                    operator: "or",
                    rules: []
                });
                break;
            case "and":
                list.push({
                    type: "operator",
                    operator: "and",
                    rules: []
                });
                break;
            case "field":
                list.push({
                    type: "field",
                    valueType: 'static',
                    fieldId: undefined,
                    value: undefined,
                    operator: undefined //>,< ,>= >=, !=
                });
                break;
            default:
                break;
        }
        _this.valid = _this.validateConditions(_this.condition.conditions);
    };

    this.getInputElements = function () {
        let elements = [];
        if (_this.use === "datasource") {
            elements.push({ id: "_startedAt", name: "Creado", type: "timestamp" })
            elements.push({ id: "closedAt", name: "Cerrado", type: "timestamp" })
            elements.push({ id: "_createdAt", name: "Subido", type: "timestamp" })
            elements.push({ id: "memberId", name: "Usuario", type: "text" });
            elements = elements.concat(BuilderDataService.getElements(null, _this.element, true, _this.form, true));
        }
        else {
            elements = BuilderDataService.getElements2(_this.form, undefined, _this.element.id, _this.isForValidator);
        }

        return elements.filter(function (element) {
            if (element.id === _this.element.id) {
                return false;
            }

            switch (element.type) {
                case "text":
                case "select":
                case "formula":
                case "number":
                case "checkbox":
                case "multiple":
                case "date":
                case "timestamp":
                case "qr":
                    return true;
                default:
                    return false;
            }
        });
    }
    this.getDynamicElements = function () {
        let elements = [];
        elements = BuilderDataService.getElements(null, _this.element);
        return elements.filter(function (element) {
            if (element.id === _this.element.id) {
                return false;
            }

            switch (element.type) {
                case "text":
                case "select":
                case "date":
                case "formula":
                case "number":
                case "checkbox":
                case "multiple":
                case "qr":
                    return true;
                default:
                    return false;
            }
        });
    }

    function walkConditions(condition) {
        if (condition.type === "field") return true;

        if (condition.type === "operator") {
            if (condition.rules.length < 2) return false;

            return condition.rules.reduce(function (acc, subRule) {
                if (!acc) return false;

                return walkConditions(subRule);
            }, true);
        }
    }

    this.validateConditions = function (conditions) {
        var valid = conditions.reduce(function (prev, rule) {
            if (!prev) return false;

            return walkConditions(rule);
        }, true);

        _this.rulesForm.$setValidity("structure", valid);
        return valid;
    };

    this.treeOptions = {
        dropped: function (sourceNodeScope, destNodesScope, destIndex) {
            _this.valid = _this.validateConditions(_this.condition.conditions);
        }
    };
    _this.lstElements = _this.getInputElements();
    // console.log(_this.lstElements);
    $scope.$watch(
        function () {
            return _this.rulesForm.$valid;
        },
        function (n, o) {
            _this.condition.valid = _this.rulesForm.$valid;
        }
    );
}
];

module.exports = function () {
    return {
        restrict: "E",
        scope: {
            condition: "=",
            element: "=",
            isForValidator:'=',
            index: "=",
            form: "=",
            use: "@",
            legend: "@",
            help: "@"
        },
        replace: true,
        controller: condition2DirectiveController,
        controllerAs: "ctrl",
        bindToController: true,
        templateUrl:
            "dashboard-builder/conditions-graph-2/requiredGraph2Directive.html"
    };
};
